import React from "react";
import styles from "./index.module.scss";
const Header = () => {
  return (
    <div className={"container" + " " + styles.container}>
      <h1 className="title"> Ваша Корзина</h1>
      <div className={styles.subtitle}>
        Вы выбрали выгодные предложения, оформите заказ, пока они есть в наличии
        и не изменилась стоимость{" "}
      </div>
    </div>
  );
};

export default Header;
